export const ASSIGNMENT_SUBMISSION_BASE_PATH = 'assignment-submission';
export const LECTURE_BASE_PATH = 'lecture';
